import { render, staticRenderFns } from "./Camps.vue?vue&type=template&id=0b2b9c39&scoped=true&"
import script from "./Camps.vue?vue&type=script&lang=js&"
export * from "./Camps.vue?vue&type=script&lang=js&"
import style0 from "./Camps.vue?vue&type=style&index=0&id=0b2b9c39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b9c39",
  null
  
)

export default component.exports